import { orderBy } from 'lodash';
import moment from 'moment';
import {
  closedStatuses,
  inProgressStatuses,
  upcomingStatuses
} from './../../utils/rentalStatuses';

const getSorted = (arr, dir = 'asc') =>
  orderBy(arr, ['reservation_start_time'], [dir]);

export const getUpcomingCarpoolings = state => {
  let rentals = state.rentals.upcomingCarpoolings;
  return getSorted(rentals);
};

export const getInProgressCarpoolings = state => {
  let rentals = state.rentals.inProgressCarpoolings;
  return getSorted(rentals);
};

export const getInProgressBookings = state => {
  let rentals = state.rentals.inProgressStatuses;
  return getSorted(rentals);
};

export const getUpcomingBookings = state => {
  let rentals = state.rentals.upcomingStatuses;
  return getSorted(rentals);
};

export const getBookingHistoryByMonth = state => {
  const history = {};
  state.rentals.closedStatuses.forEach(r => {
    const key = moment(r.reservation_end_time).format('YYYY-MM');
    (history[key] = history[key] || []).push(r);
  });
  return history;
};
